import * as types from '../actions/types'
import ActionButton from 'antd/lib/modal/ActionButton'

const intialState = {
    entity: null,
    server : null,

}

const SEGA =  "SEGA"
const ROYALMARKETING = "ROYALMARKETING"
const SEGA_SERVER = "http://127.0.0.1:8001/api"
const ROYALMARKETING_SERVER = "http://127.0.0.1:8000/api"


const entityReducer = (state = intialState , action) => {

    switch (action.type){
        case types.CHANGE_ENTITY : {
            switch (action.payload){
                case SEGA : {
                    return {
                        ...state,
                        entity : SEGA,
                        server : SEGA_SERVER
                    }
                }
                case ROYALMARKETING : {
                    return {
                        ...state,
                        entity : ROYALMARKETING,
                        server : ROYALMARKETING_SERVER
                    }
                }
                default: {
                    return {
                        ...state
                    }
                }
            }       
        }
        default : {
            return {
                ...state
            }
        }

    }
}


export default entityReducer